import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const WifiPasswordIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="30" 
      height="20"
      viewBox="0 0 30 20"
      style={{ enableBackground: "new 0 0 48 32" }}
      xmlSpace="preserve"
      {...props}
    >
      <path id="Path_132" data-name="Path 132" d="M21.591,12.294a.6.6,0,0,1,.625-.187,3.579,3.579,0,0,0,4-.937c1.438-1.438,1.625-3.687.438-4.875a.6.6,0,0,0-.875,0l-1.75,1.75-.875-.875,1.75-1.75a.6.6,0,0,0,0-.875c-1.187-1.187-3.437-.937-4.875.438a3.579,3.579,0,0,0-.937,4,.6.6,0,0,1-.187.625l-3.75,3.75a1.9,1.9,0,0,0-.25,2.438,1.718,1.718,0,0,0,1.375.75H16.4a1.7,1.7,0,0,0,1.313-.562Z" transform="translate(-5.466 -1.419)" fill="#007bc3"/>
      <path id="Path_133" data-name="Path 133" d="M28.125,16.25V1.875A1.842,1.842,0,0,0,26.25,0H3.75A1.842,1.842,0,0,0,1.875,1.875V16.25H0v.625A3.1,3.1,0,0,0,3.125,20h23.75A3.1,3.1,0,0,0,30,16.875V16.25Zm-25-14.375A.59.59,0,0,1,3.75,1.25h22.5a.59.59,0,0,1,.625.625V16.25h-9l-.625.625h-4.5l-.625-.625h-9ZM26.875,18.75H3.125a1.821,1.821,0,0,1-1.75-1.25h10.25l.625.625h5.5l.625-.625h10.25A1.821,1.821,0,0,1,26.875,18.75Z" fill="#007bc3"/>
    </StyledSVGIcon>
  );
};
